import InjuryServices from '../../services/pank_loans/injury';

export const state = {
    injuries: [],
    injury: {},
}

export const mutations = {
    setInjury(state, injury) {
        state.injury = injury
    },
    setInjuries(state, injuries) {
        state.injuries = injuries
    }
}

export const getters = {
    getInjury(state) {
        return state.injury;
    },
    getInjuries(state) {
        return state.injuries;
    },
}

export const actions = {
    get({commit}, id){
        return InjuryServices.get(id)
        .then((response)=>{
            commit('setInjury', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return InjuryServices.getAll(data)
        .then((response)=>{
            commit('setInjuries', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return InjuryServices.delete(id)
        .then((response)=>{
            commit('setInjuries', state.injuries.filter((x)=>x.id != id))
            return response
        })
    },
}